function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  className: "copy_svg__st0",
  d: "M17.3 21H9.6C8.2 21 7 19.8 7 18.3v-7.6C7 9.2 8.2 8 9.6 8h7.6c1.5 0 2.7 1.2 2.7 2.7v7.6c.1 1.5-1.1 2.7-2.6 2.7zM9.6 10c-.3 0-.6.3-.6.6v7.6c0 .5.3.8.6.8h7.6c.4 0 .7-.3.7-.7v-7.6c0-.4-.3-.7-.7-.7H9.6z"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 15h-.8c-.7 0-1.4-.3-1.9-.8-.5-.4-.8-1.1-.8-1.9V4.7A2.732 2.732 0 013.7 2h7.6c.7 0 1.4.3 1.9.8.6.5.8 1.2.8 1.9v.8c0 .6-.4 1-1 1s-1-.4-1-1v-.8c0-.2-.1-.4-.2-.5-.1-.1-.3-.2-.4-.2H3.7c-.2 0-.4.1-.5.2s-.2.3-.2.5v7.6c0 .2.1.4.2.5.1.2.3.2.5.2h.8c.6 0 1 .4 1 1s-.4 1-1 1z"
});
function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22"
  }, props), _ref, _ref2);
}
export default SvgCopy;